import { useState } from "react";
import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import SplashScreen from "@/components/feature/SplashScreen";

function App() {
  const [splashDone, setSplashDone] = useState(false);

  return (
    <I18nextProvider i18n={i18n}>
      {!splashDone && <SplashScreen onFinish={() => setSplashDone(true)} />}
      <BrowserRouter basename={__BASE_PATH__}>
        <AppRoutes />
      </BrowserRouter>
    </I18nextProvider>
  );
}

export default App;
